<template>
    <div class="index">
      <!--tab栏-->
      <ul>
        <li v-for="(item, i) in tabList" :key="i" @click="changeType(i)" :class="{active: i===showType}">
          {{item}}
        </li>
      </ul>
      <!--产品信息-->
<!--      <pro-info ref="proInfo"></pro-info>-->
      <news-list :tag="showType"></news-list>
    </div>
</template>

<script>
import proInfo from '../components/proInfo'
import newsList from './newsList'
export default {
  name: 'index',
  data () {
    return {
      showType: 0,
      tabList: [
        '足球',
        '篮球'
      ]
    }
  },
  components: {
    proInfo,
    newsList
  },
  methods: {
    changeType (index) {
      if (index === this.showType) {
        return false
      } else {
        this.showType = index
        // this.$refs.proInfo.changeShowType(index)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .index{
    width: 100%;
    >ul{
      width: 100%;
      height: 90px;
      cursor: pointer;
      li{
        position: relative;
        float: left;
        width: 50%;
        height: 100%;
        font-size: 28px;
        line-height: 90px;
        text-align: center;
        background-color: #5c72bf;
        color: #fff;
        &.active{
          background-color: #fff;
          color: #434343;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue